export const ModalLectureTableConfig = [
  {
    title: "렉처 ID",
    dataIndex: "lecture.id"
  },
  {
    title: "렉처명",
    dataIndex: "lecture.title"
  },
  {
    title: "선택",
    dataIndex: "",
    scopedSlots: {
      customRender: "choice"
    }
  }
];
